import { render, staticRenderFns } from "./PriceDetailsCard.vue?vue&type=template&id=1b987616&scoped=true"
import script from "./PriceDetailsCard.vue?vue&type=script&lang=js"
export * from "./PriceDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./PriceDetailsCard.vue?vue&type=style&index=0&id=1b987616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b987616",
  null
  
)

export default component.exports